export default "__VITE_ASSET__98c1ddd0__"